import { Component, OnInit, ViewChild } from '@angular/core';
import {FacilityService} from '../../shared/services/facility.service';
import {FacilityDetail} from '../../models/ApplicationDetail';
import {FacilityCategory, FacilityType, ProductType} from '../../models/CommonModels';
import * as Constants from '../../models/Constants';
import {AlertService} from '../../shared/services/alert.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CommonService} from '../../shared/services/common.service';
import {AccountService} from '../../services/account.service';
import {FacilityView} from '../../models/ApplicationModel';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-facility-categorize',
  templateUrl: './facility-categorize.component.html',
  styleUrls: ['./facility-categorize.component.css']
})
export class FacilityCategorizeComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  public facilities: FacilityView[] = [];
  public modifiedFacilities: any[] = [];
  public facilityCategories: FacilityCategory[];
  public searchString = '';
  public selectedFacilityTypeId: number = null;
  public selectedProductTypeId: number = null;
  public selectedFacilityCategoryId : number = null;
  public facilityTypes: FacilityType[] = [];
  public userProductTypes: ProductType[] = [];
  public allProductTypes: ProductType[] = [];
  modalRef: BsModalRef;

  constructor(private facilityService: FacilityService,
              private alertService: AlertService,
              private modalService: BsModalService,
              private commonService: CommonService,
              private accountService: AccountService,
              private spinner: NgxSpinnerService) { }
  ngOnInit() {
    this.dtOptions = this.facilityService.getFacilityListOptions(this.facilities);
    this.getAllFacilityCategories();
    this.getFacilityTypes();
    this.getProductTypes();
  }

  getUserProductTypes(): void {
    this.userProductTypes = [];

    const userDepts = this.accountService.getUserDepartmentCodes();
    if (userDepts && userDepts.length > 0) {
      userDepts.forEach( deptCode => {
        if (deptCode === 'MED') {
          this.allProductTypes.forEach(prodType => {
            if (prodType.name !== Constants.PRODUCT_TYPE_FOOD) {
              this.userProductTypes.push(prodType);
            }
          });
        } else {
          this.allProductTypes.forEach(prodType => {
            if (prodType.name === Constants.PRODUCT_TYPE_FOOD) {
              this.userProductTypes.push(prodType);
            }
          });
        }
      });
    } else {
      this.userProductTypes = this.allProductTypes;
    }


  }
  getFacilityTypes(): void {
    this.facilityTypes = [];
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => {
      this.facilityTypes = facilityTypes;
    });
  }
  getProductTypes(): void {
    this.allProductTypes = [];
    this.commonService.getProductTypes().subscribe(productTypes => {
      this.allProductTypes = productTypes;
      this.getUserProductTypes();
    });
  }

  getAllFacilityCategories() {
    this.facilityService.getAllFacilityCategories().subscribe(
      res => {
          this.facilityCategories = res.filter(f => f.name != Constants.FACILITY_CAT_UNCAT);
      }, err => {
          this.alertService.error('Error fetching facilities. Please try again later');
      }, () => {
      }
    );
  }

  categoryColor(color) {
    switch (color) {
      case Constants.FACILITY_CAT_GREEN:
        return '#1B5E20';
      case Constants.FACILITY_CAT_YELLOW:
        return '#FBC02D';
      case Constants.FACILITY_CAT_RED:
        return '#B71C1C';
    }
  }

  categorizeFacilities() {
    this.spinner.show();
    this.facilityService.categorizeFacilities(this.modifiedFacilities).subscribe(
      res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully applied category changes');
            this.modifiedFacilities = [];
            this.reloadDatatable();
          }else {
            this.alertService.error('Error applying category changes.');
          }
      }, err => {
        this.spinner.hide();
        this.alertService.error('Error applying category changes.');
      }
    );
  }

  facilityModified(facility) {
    const modifiedFacility = {
      'facilityID': facility.id,
      'facilityCategoryID': this.getFacilityCatIdForName(facility.facilityCategoryName)
    };
    this.modifiedFacilities.push(modifiedFacility);

  }
  private getFacilityCatIdForName(name) {
    return this.facilityCategories.filter(facCat => facCat.name === name)[0].id;
  }

  clearSearchString() {
    this.searchString = '';
  }

  showFilterModal(filterTemplate) {
    this.modalRef = this.modalService.show(filterTemplate, {backdrop: 'static', keyboard: false});
  }

  clearFilterParams() {
    this.selectedProductTypeId = null;
    this.selectedFacilityTypeId = null;
    this.selectedFacilityCategoryId = null;
  }

  removeFilter() {
    this.clearFilterParams();
    this.reloadDatatable();
    this.modalRef.hide();
  }

  updateDataTableFilters(){
    this.facilityService.facilityCategoryId = this.selectedFacilityCategoryId;
    this.facilityService.productTypeId = this.selectedProductTypeId;
    this.facilityService.facilityTypeId = this.selectedFacilityTypeId;
  }

  reloadDatatable(){
    this.updateDataTableFilters();
    if (this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
  }
}
